

export type ModalV5_Params = {


    // component           : any,

    toggleCallback?     : callback
    name?               : string
    placement?          : ModalPlacement

}

export enum  ModalPlacement {

    MIDDLE          = 1,
    TOP             = 2,
}